
// Long-term recommendation: Use a config object and a helper function
// for maintainability, scalability, and reduced duplication.

interface AnalyticsConfig {
  [key: string]: { title: string; screen: string };
}

export const PAGE_ANALYTICS_CONFIG: AnalyticsConfig = {
  HOMEPAGE: { title: 'Home', screen: 'Map Page' },
  LOCATION_HISTORY: { title: 'Asset Location History', screen: 'Location History Page' },
  SHOPPING_LIST: { title: 'Shopping List', screen: 'Shopping List Page' },
  MANAGE_YOUR_TEAM: { title: 'Manage Your Team', screen: 'Manage Your Team Page' },
  NOTIFICATION: { title: 'Notifications', screen: 'Notification Page' },
  SERIAL_LOOKUP: { title: 'Part Serial Lookup', screen: 'Serial Lookup Page' },
  ASSET_DETAIL: { title: 'Asset Details', screen: 'Asset Detail Page' },
  ADD_BULK_ASSET: { title: 'Bulk Asset Import', screen: 'Add Bulk Asset Page' },
  UPLOAD_ASSETS: { title: 'Upload Assets', screen: 'Upload Assets Page' },
};

// Dynamic route patterns (prefix match)
export const PAGE_ANALYTICS_PREFIX: Array<{
  prefix: string;
  title: string;
  screen: string;
}> = [
  { prefix: '/trackpro/asset-detail/', title: 'Asset Details', screen: 'Asset Detail Page' },
  { prefix: '/trackpro/part-lookup/', title: 'Part Serial Lookup', screen: 'Serial Lookup Page' },
];

export function getPageAnalyticsByPath(cleanPath: string, routePath: Record<string, string>) {
  // Try exact match by routePath key
  for (const key in PAGE_ANALYTICS_CONFIG) {
    if (cleanPath === routePath[key]) {
      const { title, screen } = PAGE_ANALYTICS_CONFIG[key];
      return {
        page_title: `${title}`,
        screen_class: screen,
      };
    }
  }
  // Try prefix match for dynamic routes
  for (const entry of PAGE_ANALYTICS_PREFIX) {
    if (cleanPath.startsWith(entry.prefix)) {
      return {
        page_title: `${entry.title}`,
        screen_class: entry.screen,
      };
    }
  }
  // Default fallback
  return {
    page_title: `${cleanPath}`,
    screen_class: 'Unknown Page',
  };
}
